import { TuiElasticContainer } from '@taiga-ui/layout';
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output, TemplateRef } from '@angular/core';
import { SadmEntityDisplay } from '@modules/sadm/models/sadm-entity-display';
import { SadmType } from '@pixacare/domain';
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';
import { TuiSkeleton } from '@taiga-ui/kit';
import { SadmEntityPreviewComponent } from '../sadm-entity-preview/sadm-entity-preview.component';
import { SadmEntitySelectComponent } from '../sadm-entity-select/sadm-entity-select.component';

@Component({
  selector: 'pxc-sadm-entity-select-list',
  templateUrl: './sadm-entity-select-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block',
  },
  imports: [
    EmptyStateComponent,
    NgTemplateOutlet,
    SadmEntityPreviewComponent,
    SadmEntitySelectComponent,
    TuiSkeleton,
    TuiElasticContainer,
  ],
})
export class SadmEntitySelectListComponent {
  readonly entities = input<SadmEntityDisplay[]>([]);
  readonly loading = input<boolean>(false);
  readonly selectedId = input<number | null>(null);
  readonly emptyMessage = input<string>('');
  readonly emptyTemplate = input<TemplateRef<unknown>>();
  readonly sadmType = input<SadmType>();
  readonly skeletonCount = input<number>(3);

  readonly selectedIdChange = output<number>();

  protected readonly skeletons = computed(() => Array.from({ length: this.skeletonCount() }));
}
